import {
  Box,
  TextField,
  FormControl,
  MenuItem,
  Typography,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  rootTextField: {
    flexDirection: "row",
    // minWidth: '86px',
    // '& .MuiTextField-root': {
    //     margin: theme.spacing(1),
    //     // width: '25ch',
    // },
    // '& .MuiInputLabel-formControl': {
    //     position: 'relative',
    //     [theme.breakpoints.up('sm')]: {
    //         marginRight: theme.spacing(1),
    //     },
    // }
  },
  paging: {
    margin: theme.spacing(0, 2),
  },
  paginationPadding: {
    padding: theme.spacing(0.5, 0),
  },
  divider: {
    backgroundColor: "#ccc5c5",
  },
}));

const rowsList = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 30, value: 30 },
  { label: 40, value: 40 },
  { label: 50, value: 50 },
  { label: 60, value: 60 },
  { label: 70, value: 70 },
];

export default function Paging(props) {
  const classes = useStyles();

  const handleRowPerPageChange = (value) => {
    props.handleRowPerPageChange(value);
  };

  return (
    <div className={classes.root} id="pagination">
      <Box
        display="flex"
        justifyContent={`${props.position}?${props.position}:'center'`}
        alignItems="center"
        mb={0.5}
        className={`${classes.paging} ${
          props.cssClassName ? props.cssClassName : null
        }`}
      >
        {/* <Typography variant="caption" alignItems="center" style={{ paddingRight: '5px' }}> Page</Typography> */}
        <FormControl variant="outlined" className={classes.rootTextField}>
          <TextField
            id="outlined-select-leagueId-native"
            name="outlined-select-leagueId-native"
            select
            value={props.pagingInfo.rowsPerPage}
            onChange={(e) => handleRowPerPageChange(e.target.value)}
            variant="outlined"
            size="small"
          >
            {rowsList
              ? rowsList.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))
              : null}
          </TextField>
        </FormControl>
        <Pagination
          count={props.pagingInfo.noOfPages ? props.pagingInfo.noOfPages : 0}
          page={props.pagingInfo.currentPage}
          onChange={(e, val) => {
            props.onPageChange(val);
          }}
          defaultPage={1}
          color="primary"
          showFirstButton
          showLastButton
          siblingCount={0}
          boundaryCount={1}
        />
      </Box>
    </div>
  );
}
